import { Subject, Observable } from 'rxjs';
import { SdFilterPanelClosedEvent, SdFilterPanelContent, FilterPanelResult, FilterPanelConfig } from './types';
import { OverlayRef } from '@angular/cdk/overlay';
import { FilterPanelCloseType } from './constants';

export class SdFilterPanelRef {

    private _afterClosed = new Subject<SdFilterPanelClosedEvent<FilterPanelResult>>();
    afterClosed$: Observable<SdFilterPanelClosedEvent<FilterPanelResult>> = this._afterClosed.asObservable();

    private _beforeClosedOnBackdropClick = new Subject<void>();
    beforeClosedOnBackdropClick$: Observable<void> = this._beforeClosedOnBackdropClick.asObservable();

    constructor(public overlayRef: OverlayRef, public config: FilterPanelConfig, public content: SdFilterPanelContent, public inputDataType: string) {
        const panelResult: FilterPanelResult = {
            resultType: FilterPanelCloseType.backdropClick,
            data: null,
            type: config.type
        };
        overlayRef.backdropClick().subscribe(() => {
            this._beforeClosedOnBackdropClick.next();
            this.closed(panelResult);
        });
    }

    close(result?: FilterPanelResult) {
        if (result) {
            this.closed(result);
        }
    }


    private closed(result: FilterPanelResult) {
        this.overlayRef.dispose();
        this._afterClosed.next({ dialogData: result });

        this._afterClosed.complete();
    }

}
